import VueCookies from 'vue-cookies'

export default {

    toRoot() {
        VueCookies.remove("edu-site-org")
        window.location.href = '/'
    },

    toRootName(){
        VueCookies.remove("edu-site-name")
        window.location.href = '/'

    },
    getOrg() {
        let orgId = VueCookies.get("edu-site-org");
        if (orgId) {
            return orgId;
        }
        this.toRoot()
    },
    setOrg(orgId) {
        VueCookies.set("edu-site-org", orgId)
    },

    getName() {
        let name = VueCookies.get("edu-site-name");
        if (name) {
            return name;
        }
        this.toRoot()
    },
    setName(name) {
        VueCookies.set("edu-site-name", name)
    },

    getId() {
        let name = VueCookies.get("edu-site-id");
        if (name) {
            return name;
        }
        this.toRoot()
    },
    setId(id) {
        VueCookies.set("edu-site-id", id)
    }

}